
export const shouldShowField = (deliverableType, field) => {
  switch (field) {
    case "reportingEntity":
    case "reportingType":
      return deliverableType === "cashManagement";
    default:
      return false;
  }
};

